function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ExternalLinkIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.5v5c0 2.5-2 4.5-4.5 4.5h-13C2 26 0 24 0 21.5v-13C0 6 2 4 4.5 4h11c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-11C3.1 6 2 7.1 2 8.5v13C2 22.9 3.1 24 4.5 24h13c1.4 0 2.5-1.1 2.5-2.5v-5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5zM28 3v8c0 .5-.5 1-1 1-.3 0-.5-.1-.7-.3L23.5 9 13.4 19.1c-.1.1-.2.2-.4.2s-.3-.1-.4-.2l-1.8-1.8c-.1-.1-.2-.2-.2-.4s.1-.3.2-.4L21 6.5l-2.8-2.8c-.1-.2-.2-.4-.2-.7 0-.5.5-1 1-1h8c.5 0 1 .5 1 1z"
  }));
};
export default ExternalLinkIcon;